import { get } from "../security/secureClient";

export const getTiles = (): Promise<string> => get("tiles/gethomepagecontent");
